import * as tslib_1 from "tslib";
import { AuthService } from "./auth.service";
import { environment } from "../../environments/environment";
var ACTIVITY_EVENTS = ["mousemove", "keydown", "click", "scroll", "touchstart"];
/** Check inactivity every 30 seconds so we detect timeout soon after it elapses. */
var INACTIVITY_CHECK_INTERVAL_MS = 30 * 1000;
var SessionHeartbeatService = /** @class */ (function () {
    function SessionHeartbeatService(authService) {
        var _this = this;
        this.authService = authService;
        this.lastActivity = Date.now();
        // private warningShown = false; // Unused when warning popup is commented out
        this.timer = null;
        this.expiring = false;
        this.started = false;
        this.cfg = null;
        this.baseUrl = "";
        ACTIVITY_EVENTS.forEach(function (evt) {
            return document.addEventListener(evt, function () {
                _this.lastActivity = Date.now();
                // this.warningShown = false; // Unused when warning popup is commented out
            }, { passive: true });
        });
    }
    SessionHeartbeatService.prototype.start = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var cfg;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.started || !this.authService.authenticated)
                            return [2 /*return*/];
                        this.started = true;
                        return [4 /*yield*/, this.loadConfig()];
                    case 1:
                        cfg = _a.sent();
                        if (!cfg || !cfg.authAuthority)
                            return [2 /*return*/];
                        this.cfg = cfg;
                        this.baseUrl = (environment.baseFixUrl || "").replace(/\/+$/, "");
                        this.checkInactivity();
                        this.timer = window.setInterval(function () { return _this.checkInactivity(); }, INACTIVITY_CHECK_INTERVAL_MS);
                        return [2 /*return*/];
                }
            });
        });
    };
    SessionHeartbeatService.prototype.stop = function () {
        if (this.timer != null) {
            window.clearInterval(this.timer);
            this.timer = null;
        }
        this.started = false;
    };
    SessionHeartbeatService.prototype.loadConfig = function () {
        var baseUrl = (environment.baseFixUrl || "").replace(/\/+$/, "");
        var url = baseUrl ? baseUrl + "/api/session/config" : "";
        if (!url)
            return Promise.resolve(null);
        return fetch(url, { method: "GET", credentials: "include" })
            .then(function (res) { return (res.ok ? res.json() : null); })
            .catch(function () { return null; });
    };
    SessionHeartbeatService.prototype.getLogoutRedirectUrl = function () {
        var logoutUrl = this.cfg && this.cfg.logoutUrl ? this.cfg.logoutUrl : null;
        if (!logoutUrl)
            return Promise.resolve(null);
        var fullUrl = logoutUrl.startsWith("http") ? logoutUrl : "" + this.baseUrl + logoutUrl;
        return fetch(fullUrl, { method: "GET", credentials: "include" })
            .then(function (res) { return (res.ok ? res.json() : null); })
            .then(function (data) {
            return data && data.Success && typeof data.Data === "string" ? data.Data : null;
        })
            .catch(function () { return null; });
    };
    SessionHeartbeatService.prototype.buildLoginUrl = function () {
        var authAuthority = (this.cfg && this.cfg.authAuthority) || "";
        var returnUrl = window.location.href;
        return authAuthority + "/Login?returnUrl=" + encodeURIComponent(returnUrl);
    };
    SessionHeartbeatService.prototype.checkInactivity = function () {
        var _this = this;
        if (!this.cfg || !this.authService.authenticated || this.expiring)
            return;
        var inactivityMs = (this.cfg.inactivityMinutes != null ? this.cfg.inactivityMinutes : 30) * 60 * 1000;
        var idleMs = Date.now() - this.lastActivity;
        if (idleMs >= inactivityMs) {
            this.expiring = true;
            this.stop();
            this.getLogoutRedirectUrl().then(function (redirectUrl) {
                var url = redirectUrl || _this.buildLoginUrl();
                _this.authService.logout();
                window.location.href = url;
            });
        }
    };
    return SessionHeartbeatService;
}());
export { SessionHeartbeatService };
